module.exports = [{"label":"pro Tag","value":"tag"},{"label":"pro Woche","value":"woche"},{"label":"pro Monat","value":"monat"}]


//////////////////
// WEBPACK FOOTER
// ./src/db/warenlieferungZeiteinheit.json
// module id = 622
// module chunks = 0